import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { unaryRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const hasReturnableItems = unaryRpc({
  name: "hasReturnableItems",
  input: z.object({
    orderId: z.string(),
    returnType: createEnum(ReturnTypeEnum),
  }),
  output: z.boolean(),
});
